import { render, staticRenderFns } from "./FormDefinitionJsonList.vue?vue&type=template&id=3b5a743a&scoped=true"
import script from "./FormDefinitionJsonList.vue?vue&type=script&lang=js"
export * from "./FormDefinitionJsonList.vue?vue&type=script&lang=js"
import style0 from "./FormDefinitionJsonList.vue?vue&type=style&index=0&id=3b5a743a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5a743a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b5a743a')) {
      api.createRecord('3b5a743a', component.options)
    } else {
      api.reload('3b5a743a', component.options)
    }
    module.hot.accept("./FormDefinitionJsonList.vue?vue&type=template&id=3b5a743a&scoped=true", function () {
      api.rerender('3b5a743a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/form/FormDefinitionJsonList.vue"
export default component.exports